export function getSystemTheme() {
  const isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)'); // 是深色
  // console.log('isDarkTheme', isDarkTheme);
  if (isDarkTheme.matches) {
    // 是深色
    return 'dark';
  } else {
    // 不是深色
    return 'light';
  }
}

/** 设置显示模式 */
export function setMode(mode) {
  if (mode) {
    document.documentElement.setAttribute('theme', 'dark');
  } else {
    document.documentElement.removeAttribute('theme');
  }
}
